var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.signature)?_c('modal',{ref:"modal_signature",attrs:{"title":_vm.userComputed?.full_name ?? 'Operative',"subtitle":_vm.signature.created_at_formatted,"close_on_focus":true,"left_title":true}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.signature.url,"alt":`${_vm.userComputed?.full_name}'s signature`}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }